import { ButtonRedOutline, TopMenu } from "../../../../common";

export const SessionExecutionMenu = () => {
    return (
        <TopMenu>
            <>
                <ButtonRedOutline margintop="0" marginbottom="0" height="40px" width="120px">
                    Finalizar
                </ButtonRedOutline>
            </>
        </TopMenu>
    );
};